<template>
    <div class="table-container">
        <br>
        <div v-if="patient.sottoscrizione.length === 0" class="p-6 text-center text-gray-600">
            Nessuna sottoscrizione attiva
        </div>
        <table v-else class="styled-table">
            <thead class="accessColor">
                <th>Sottoscrizione attiva:</th>
                <th>Data d'inizio</th>
                <th>Importo</th>
                <th>Data di scadenza</th>
                <th>Azioni</th>
            </thead>
            <tbody>
                <tr v-for="subscription in patient.sottoscrizione" :key="subscription.id"
                    class="border-b border-gray-200 hover:bg-gray-100">
                    <td class="grid-item">{{ subscription.licenze.descrizione }}</td>
                    <td class="grid-item">{{ formatDate(subscription.created_at) }}</td>
                    <td class="grid-item">{{ subscription.licenze.costo }} €</td>
                    <td class="grid-item">{{ formatDate(subscription.data_scadenza) }}</td>
                    <td class="grid-item">
                        <button @click="deleteSubscription(subscription)"
                            class="ml-4 text-red-600 hover:underline">Annulla</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="containerPaypal">
        <div v-for="(contratto, index) in contrattiLocali" :key="contratto.id" class="paypalGroup">
            <span>
                <div class="plan-title">
                    <h1> <strong> {{ contratto['descrizione'] }} </strong> </h1>
                </div>
                <div class="plan-costo">
                    <h3> <strong> {{ contratto['costo'] + $t(' £') }} </strong> </h3>
                </div>
                <div class="plan-description">{{ contratto['id_paypal_descrizione_piano'] }}</div>
            </span>
            <div>
                <h2 class="title-box">Leggi tutto il contratto</h2>
                <div class="contract-box" @scroll="checkScrollEnd(index, $event)">
                    <div class="contract-text">
                        {{ contratto['testo_contratto'] }}
                    </div>
                </div>
                <label :disabled="!contratto.terminatoLettura"
                    :class="{ 'disabled-checkbox': !contratto.terminatoLettura }">
                    <input class="contract-accept-box" type="checkbox" v-model="contratto.accettato"
                        :disabled="!contratto.terminatoLettura"
                        :class="{ 'disabled-checkbox': !contratto.terminatoLettura }" />
                    Accetto i termini del contratto
                </label>
                <div :ref="'element' + contratto.id" class="paypalbtn" :hidden="!contratto.accettato">
                </div>
            </div>
        </div>
    </div>
    <div style="margin: 3%; padding: 0% 20% 10% 20%;">
        <img src="../../assets/images/sottoscrizioni.jpg">
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { patientStore } from '@/store/patient'
import { authStore } from '@/store/authorize';
import { storeToRefs } from 'pinia'

export default {
    setup() {

        const store = patientStore();
        const auth = authStore();
        const { patient } = storeToRefs(store);
        const contrattiLocali = ref([]);

        onMounted(() => {
            contrattiLocali.value = patient.value.contratti.contratti.map(contratto => ({
                ...contratto,
                accettato: false,
                terminatoLettura: false
            }));
        });

        const checkScrollEnd = (index, event) => {
            const box = event.target;
            if (box.scrollTop + box.clientHeight >= box.scrollHeight) {
                contrattiLocali.value[index].terminatoLettura = true;
            }
        };

        const accettaContratto = (index) => {
            if (contrattiLocali.value[index].terminatoLettura) {
                contrattiLocali.value[index].accettato = true;
            } else {
                alert(`Devi leggere completamente il contratto ${index + 1} prima di accettarlo.`);
            }
        };

        return {
            patient,
            contrattiLocali,
            checkScrollEnd,
            accettaContratto
        };
    },
    mounted() {
        this.setPaypal();
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            return date.toLocaleDateString('it-IT', { day: "numeric", month: "numeric", year: 'numeric' });
        },

        deleteSubscription(subscription) {
            alert(`Annulla sottoscrizione`);
        },

        setPaypal: function () {
            const script = document.createElement('script');
            script.src = "https://www.paypal.com/sdk/js?client-id=" + "AaGUe6jZrp7HLmHquavEwb3WpjQ41XQgYMzqSpejPPSMJlXw_VzBnZrsLQ0DUmG9HrHMHKLqqfFrobpu" + "&vault=true&intent=subscription";
            document.body.appendChild(script);
            script.addEventListener('load', () => this.setLoaded())
        },

        setLoaded: function () {
            const patientData = this.patient;
            if (!patientData || !patientData.user) {
                return;
            }

            let contracts = patientData.contratti.contratti;
            for (let deal of contracts) {
                let refname = "element" + deal.id;
                window.paypal.Buttons({
                    createSubscription: function (data, actions) {
                        return actions.subscription.create({
                            plan_id: deal.id_paypal_codice_piano
                        })
                    },
                    onApprove: (data, actions) => {
                        return fetch('/api/paypal/order/capture', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-Token': '{{ csrf_token() }}'
                            },
                            body: JSON.stringify({
                                orderId: data.orderID,
                                subscriptionId: data.subscriptionID,
                                id_utente: patientData.user.id_utente,
                                email: patientData.user.email,
                                planid: deal.id_paypal_codice_piano,
                            })
                        })
                    },
                    onError: err => {
                        window.alert(err);
                    }
                })
                    .render(this.$refs[refname][0]);
            }
        }
    }
};
</script>

<style scoped>
.containerPaypal {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
    gap: 30px;
    padding: 1% 5%;
}

.paypalGroup {
    padding: 20px;
    height: auto;
    border: 1px solid rgb(3, 55, 26);
    margin-top: 2%;
    margin-left: 4%;
    border-radius: 2%;
    z-index: 2;
}

.paypalbtn {
    margin-left: 10%;
    margin-right: 10%;
    width: 80%;
    height: 20%;
    margin-top: 5%;
    z-index: 1;
    position: relative;
}

.plan-costo {
    margin-left: 4%;
    font-size: 15px;
    color: rgb(3, 55, 26);
}

.plan-title {
    margin-left: 4%;
    margin-bottom: 3%;
    margin-top: 5%;
    color: rgb(21, 21, 170);
    font-size: 18px;
}

.plan-description {
    margin-left: 4%;
    margin-right: 10%;
}

.contract-container {
    margin-bottom: 20px;
    margin-left: 4%;
}

.title-box {
    margin: 2% 4%;
}

.contract-accept-box {
    margin: 5% 1% 5% 4%;
}

.contract-box {
    border: 1px solid #ccc;
    padding: 20px;
    max-height: 200px;
    margin-left: 4%;
    margin-right: 4%;
    /* Altezza massima del box */
    overflow-y: auto;
    /* Aggiungi uno scroll verticale se necessario */
}

.contract-text {
    margin-bottom: 10px;
    /* Aggiungi un margine inferiore per separare la casella di controllo */
}

.disabled-checkbox {
    opacity: 0.2;
    /* Rende la checkbox trasparente quando è disabilitata */
}

.styled-table {
    display: grid;
    border-collapse: collapse;
    min-width: 100%;
    grid-template-columns: minmax(200px, 0fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr) minmax(120px, 1.67fr) minmax(120px, 1.67fr);
    grid-auto-rows: minmax(auto, max-content);
}

.grid-item {
    word-wrap: break-word;
}

.table-container {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;
    padding-bottom: 0px;
}

.styled-table {
    width: 100%;
    border-collapse: collapse;
    margin: 0px;
    font-size: 18px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    overflow: hidden;
    word-wrap: break-word;
    /* Permette al testo lungo di andare a capo */
    table-layout: fixed;
    /* Mantiene la larghezza delle colonne fissata */
}

.styled-table thead tr {
    background-color: #009879;
    color: #ffffff;
    text-align: left;
    font-weight: bold;
}

.styled-table th,
.styled-table td {
    padding: 12px 15px;
    border-bottom: 1px solid #dddddd;
    vertical-align: top;
    white-space: normal;
}

.styled-table tbody tr {
    border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
    background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
    border-bottom: 2px solid #009879;
}

.styled-table tbody tr.active-row {
    font-weight: bold;
    color: #009879;
}

.styled-table tbody tr:hover {
    background-color: #f1f1f1;
    cursor: pointer;
}
</style>